import { Injectable, inject } from '@angular/core';
import { ApiUrl, IrisBaseCRUDService, IrisQueryParamsBuilder } from '@iris/api-query';
import { HttpClient } from '@angular/common/http';
import { IrisTagI, IrisSelectedTagI } from '@iris/common/models/IrisTag';
import { Observable } from 'rxjs';
import { IrisQueryParams } from '@iris/api-query';
import { IrisDMSTagI } from '@iris/common/modules/dms/models/IrisDMSTag';
import { DMSProject } from '@iris/common/modules/dms/components/tags/models/dms-project';

@Injectable({ providedIn: 'root' })
@ApiUrl('/tags')
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class IrisTagsService extends IrisBaseCRUDService<any> {
  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient);
  }

  @ApiUrl('~/{scope}/{id}')
  getByScope(id: number, scope: string, params: IrisQueryParams = new IrisQueryParams()): Observable<IrisSelectedTagI[]> {
    return this.httpClient.get<IrisSelectedTagI[]>(this.url({ scope, id }), { params: params.toObject() });
  }

  @ApiUrl('~/v2/{entityName}/{id}/{tagId}')
  saveByScope(id: number, tagId: number, entityName: string): Observable<IrisTagI> {
    return this.httpClient.post<IrisTagI>(this.url({ entityName, id, tagId }), {});
  }

  @ApiUrl('~/{entityName}/{id}/{tagId}')
  removeByScope(id: number, tagId: number, entityName: string): Observable<unknown> {
    return this.httpClient.delete<IrisTagI>(this.url({ entityName, id, tagId }));
  }

  @ApiUrl('~/list')
  saveTags(tags: object[]): Observable<unknown> {
    return this.httpClient.post(this.url(), tags);
  }

  save(tag: IrisTagI): Observable<IrisTagI> {
    return this.httpClient.post<IrisTagI>(this.url(), tag);
  }

  @ApiUrl('~/dms/projects/{projectId}')
  getDmsProjectTags(projectId: number, calcualteFileCount = false): Observable<IrisDMSTagI[]> {
    const params = new IrisQueryParamsBuilder();
    if (calcualteFileCount) {
      params.urlParam('fileCount', true);
    }
    return this.httpClient.get<IrisDMSTagI[]>(this.url({ projectId }), { params: params.toStructure().toObject() });
  }

  @ApiUrl('~/dms/public')
  getDmsPublicTags(calcualteFileCount = false): Observable<IrisDMSTagI[]> {
    const params = new IrisQueryParamsBuilder();
    if (calcualteFileCount) {
      params.urlParam('fileCount', true);
    }
    return this.httpClient.get<IrisDMSTagI[]>(this.url(), { params: params.toStructure().toObject() });
  }

  @ApiUrl('~/dms/info')
  getDmsTagsInfo(): Observable<IrisDMSTagI[]> {
    return this.httpClient.get<IrisDMSTagI[]>(this.url());
  }

  @ApiUrl('~/dms/projects/{projectId}/by-name?name={tagName}')
  getProjectTagByName(projectId: number, tagName: string): Observable<IrisDMSTagI> {
    return this.httpClient.get<IrisDMSTagI>(this.url({ projectId, tagName }));
  }

  @ApiUrl('~/dms/public/by-name?name={tagName}')
  getPublicTagByName(tagName: string): Observable<IrisDMSTagI> {
    return this.httpClient.get<IrisDMSTagI>(this.url({ tagName }));
  }

  @ApiUrl('~/projects/')
  getProjectsWithTheSameTag(params: IrisQueryParams = new IrisQueryParams()): Observable<DMSProject[]> {
    return this.httpClient.get<DMSProject[]>(this.url(), { params: params.toObject() });
  }
}
